import { render, staticRenderFns } from "./Appointments.vue?vue&type=template&id=7c7cc8fe&scoped=true&"
import script from "./Appointments.vue?vue&type=script&lang=js&"
export * from "./Appointments.vue?vue&type=script&lang=js&"
import style0 from "./Appointments.vue?vue&type=style&index=0&id=7c7cc8fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7cc8fe",
  null
  
)

export default component.exports